import { OrmCustomerOrderContactSet } from "@natiwi/shared/models/customer-order.model";
import { NatDocumentItemController } from "@natiwi/core/controllers/document-item.controller";

export class NatCustomerOrderContactSetController extends NatDocumentItemController<OrmCustomerOrderContactSet>{

    constructor() {
        super();
        super.registerDataClass(OrmCustomerOrderContactSet);
    }
}